export default {"src":"/_next/static/media/audio_play.3cdc1d88.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};